import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    outline: 0;
  }

  body {
    font-family: 'Inter', sans-serif;
    /* Puedes ajustar otros estilos aquí, como el tamaño de fuente, color, etc. */
  }

  .navbar {
    border-bottom: 6px solid  ${(props) => props.theme.colors.primary};
    border-top: none;
    border-left: none;
    border-right: none;
    background: ${(props) => props.theme.colors.primaryLight};
    padding: 12px;
  }

  .bg-gray {
    background-color: ${(props) => props.theme.colors.lightLight};
  }

  h1 {
    font-family: 'Inter', sans-serif;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  a.text-navy:hover, a.text-navy:focus {
    background-color: ${(props) => props.theme.colors.light};
    border-radius: 0;
    color: ${(props) => props.theme.colors.primary};
    text-align: center;
    padding: 8px;
    text-decoration:none;
  }

  btn:focus, .btn.focus {
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  * para el chatbot */
  .bFYSEa {
    height: auto !important;
    width: 186px !important;
  }

  /* server de produccion */
  .hLgJkJ {
    height: auto !important;
    width: 186px !important;
  }

  .gosdHH {
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    cursor: pointer;
    background: transparent !important;
    bottom: 32px;
    border-radius: 0;
    box-shadow: none !important;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    fill: #fff;
    height: 60px;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    position: fixed;
    right: 32px !important;
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
    -webkit-transition: -webkit-transform 0.3s ease;
    -webkit-transition: transform 0.3s ease;
    transition: transform 0.3s ease;
    width: 186px !important;
    z-index: 999;
  }

  .hzaEDp {
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    cursor: pointer;
    background: transparent !important;
    bottom: 32px;
    border-radius: 0;
    box-shadow: none !important;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    fill: #fff;
    height: 60px;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    position: fixed;
    right: 32px !important;
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
    -webkit-transition: -webkit-transform 0.3s ease;
    -webkit-transition: transform 0.3s ease;
    transition: transform 0.3s ease;
    width: 186px !important;
    z-index: 999;
  }

  .flotante2 {
    display: scroll;
    position: fixed;
    bottom: -26px;
    right: -0.4rem;
    /* background-color: #ffdd00; */
    padding: 0.5rem 2rem;
    z-index: 900;
    float: right;
    color: ${(props) => props.theme.colors.light};
    font-weight: bolder;
    font-size: 1.2rem;
    border-radius: 16px;
    cursor: pointer;
  }

  /* chat bot*/
  .flotante-chat {
    display: flex;
    align-items: center;
    position: fixed;
    bottom: -0.6rem;
    right: -0.4rem;
    background-color:${(props) => props.theme.colors.primary};
    padding: 12px 18px 18px 18px;
    z-index: 900;
    float: right;
    color: ${(props) => props.theme.colors.light};
    font-weight: bolder;
    font-size: 24px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0,0,0,0.3);
  }

  .avatar-kielsa {
    margin-left: -208px !important;
    margin-top: 5px;
  }

  .avatar-usuario {
    margin-left: 213px !important;
    margin-top: 10px;
  }

  #tarjeta-chat {
    background-color: #fff;
    position: absolute;
    right: 1rem;
    z-index: 1000;
    display: scroll;
    position: fixed;
    bottom: 0px;
    width: 300px;
    float: right;
    max-height: 400px;
    box-shadow: none !important;
  }
  .flotante-derecha {
    margin-left: 3rem;
  }

  .container-chat {
    border: 2px solid #dedede;
    background-color: #dbdbdd;
    color: ${(props) => props.theme.colors.primary};
    border-color: #dbdbdd;
    border-radius: 8px;
    padding: 8px;
    margin-top: 10px;
    /* margin-bottom: 5px; */
    margin-left: 36px;
    /* top: -11px; */
  }

  /* Darker chat container */
  .container-darker {
    border-color: #dbdbdd;
    background-color: #dbdbdd;
    color: ${(props) => props.theme.colors.primary};
    border-radius: 5px;
    padding: 8px;
    margin-top: -25px;
    margin-bottom: 5px;
    margin-right: 40px;
    top: -11px;
  }

  // carrousel
  .my__carousel_main  button{
    width: 10px !important;
    height: 10px !important;
    border-radius: 50% !important;
  }

  /* Clear floats */
  .container-chat::after {
    content: "";
    clear: both;
    display: table;
  }

  /* Style images */
  .container-chat img {
    float: left;
    max-width: 60px;
    width: 100%;
    margin-right: 20px;
    border-radius: 50%;
  }

  /* Style the right image */
  .container-chat img.right {
    float: right;
    margin-left: 20px;
    margin-right: 0;
  }

  /* Style time text */
  .time-right {
    float: right;
    color: #fff;
  }

  /* Style time text */
  .time-left {
    float: left;
    color: #fff;
  }

  .Card-list-msg {
    height: Calc(100%-5rem) !important;
    overflow-y: scroll;
    position: relative;
    scrollbar-width: thin;
    scrollbar-color: ${(props) => props.theme.colors.secondary};
  }
  .custom-link {
    color:white;
    &:hover{
      color:${(props) => props.theme.colors.tertiary};
    }
  }
  /* chat bot end*/
  .carousel-inner{
    position:relative
  }
  .carousel-custom-next{
    position: absolute;
   /* right: -20px;*/
    top:50%;
    transform:translateY(-50%);
    z-index:10;
    border: 0;
    background: transparent;
  }
  .carousel-custom-previous{
    position: absolute;
    /*left:-20px;*/
    top:50%;
    transform:translateY(-50%);
    z-index:10;
    border: 0;
    background: transparent;
  }

  .carousel-indicators [data-bs-target]{
    border-radius: 100%;
    width: 10px;
    height: 10px;
  }
  .breadcrumb {
    margin-bottom: 0;
    font-size: 14px;
    color: ${(props) => props.theme.colors.primary};
    font-weight: 500;
  }

.custom-radio .form-check-input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.custom-radio .form-check-label {
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  display: inline-block;
}

.custom-radio .form-check-label::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 20px;
  height: 20px;
  background-color: ${(props) => props.theme.colors.primaryComplementary1};
  border-radius: 50%;
  transform: translateY(-50%);
}

.custom-radio .form-check-label.active::before {
  background-color: ${(props) => props.theme.colors.secondaryAccent};
}

.custom-radio .form-check-label::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 7px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: white;
  transition: transform 0.3s ease;
  transform: scale(0);
  transform: translateY(-50%);
}

.custom-radio .form-check-input:checked + .form-check-label::after {
  transform: scale(1);
}

.style-arrow-carrousel {
  background-color: #40b1e5;
  color: white;
  border-radius: 50px;
  padding: 5px;
  box-shadow: 0px 5px 7px 0px rgba(208, 207, 207, 0.60);
}

.map-container {
  width: 100% !important;
  height: 100vh !important;
  max-height: 80%; /* Ajusta este valor según lo necesites */
  margin-bottom: 1rem !important;
  position: relative !important;
}

@media (max-width: 768px) {
  .style-arrow-carrousel {
    padding: 12px;
    margin: 12px;
  }
}

@media (max-width: 330px) {
  .rccs__card {
    width: 240px;
    margin: 0;
  }
}

 /*mansory gallery style*/
  .my-masonry-grid {
    display: flex;
    margin-left: -30px;
    width: auto;
  }
  
  .my-masonry-grid_column {
    padding-left: 30px;
    background-clip: padding-box;
  }
  
  .image-item {
    margin-bottom: 30px;
  }
  
  .image-item img {
    width: 100%;
    height: auto;
    border-radius: 5px;
  }
  
  /*end mansory gallery style*/
  .pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom:20px;
}

.pagination button {
  margin: 0 5px;
  padding: 10px;
  background-color: #f0f0f0;
  border: 1px solid #ddd;
  cursor: pointer;
}

.pagination button.active {
  background-color:${(props) => props.theme.colors.primary};
  color: white;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

`;

export default GlobalStyle;
